// src/pages/EditProfile.js
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import avt from '../assets/images/avatar/avata_profile.jpg'
import useUserStore from '../stores/userStore'
import useToastStore from '../stores/toastStore'

const EditProfile = () => {
    const { profile, fetchProfile, updateProfile, loading } = useUserStore()
    const { addToast } = useToastStore()
    const [formData, setFormData] = useState({
        phone: '',
        bank_name: '',
        bank_account_name: '',
        bank_account_num: '',
    })

    useEffect(() => {
        fetchProfile()
    }, [fetchProfile])

    useEffect(() => {
        if (profile) {
            setFormData({
                phone: profile.phone || '',
                bank_name: profile.bank_name || '',
                bank_account_name: profile.bank_account_name || '',
                bank_account_num: profile.bank_account_num || '',
            })
        }
    }, [profile])

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const result = await updateProfile({ user: formData })
        // if (result.success) {
        addToast('Profile updated successfully!', 'success')
        // } else {
        //     addToast('Failed to update profile.', 'danger')
        // }
    }

    return (
        <div>
            <Header />
            <div className="tf-create-item tf-section">
                <div className="themesflat-container">
                    <div className="row">
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                            {/*<div className="sc-card-profile text-center">
                                <div className="card-media">
                                    <img id="profileimg" src={avt} alt="Profile" />
                                </div>
                                <div id="upload-profile">
                                    <Link to="#" className="btn-upload">
                                        Upload New QR Code
                                    </Link>
                                    <input id="tf-upload-img" type="file" name="profile" required />
                                </div>
                                <Link to="#" className="btn-upload style2">
                                    Delete
                                </Link>
                            </div>*/}
                        </div>
                        <div className="col-xl-9 col-lg-8 col-md-12 col-12">
                            <div className="form-upload-profile">
                                <form className="form-profile" onSubmit={handleSubmit}>
                                    <div className="form-infor-profile">
                                        <div className="info-account">
                                            <h4 className="title-create-item">Thông tin tài khoản</h4>
                                            <fieldset>
                                                <h4 className="title-infor-account">Email</h4>
                                                <input type="text" value={profile.email} disabled />
                                            </fieldset>
                                            <fieldset>
                                                <h4 className="title-infor-account">Số điện thoại</h4>
                                                <input
                                                    type="number"
                                                    name="phone"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    placeholder="Enter your phone number"
                                                    required
                                                />
                                            </fieldset>

                                            <h4 className="title-create-item">Thông tin tài khoản ngân hàng</h4>
                                            <fieldset>
                                                <h4 className="title-infor-account">Tên ngân hàng</h4>
                                                <input
                                                    type="text"
                                                    name="bank_name"
                                                    value={formData.bank_name}
                                                    onChange={handleChange}
                                                    placeholder="Enter your bank"
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <h4 className="title-infor-account">Chủ tài khoản</h4>
                                                <input
                                                    type="text"
                                                    name="bank_account_name"
                                                    value={formData.bank_account_name}
                                                    onChange={handleChange}
                                                    placeholder="Enter your bank account name"
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <h4 className="title-infor-account">Số tài khoản</h4>
                                                <input
                                                    type="number"
                                                    name="bank_account_num"
                                                    value={formData.bank_account_num}
                                                    onChange={handleChange}
                                                    placeholder="Enter your bank account number"
                                                />
                                            </fieldset>
                                        </div>
                                        <div className="info-social">
                                            {/*<h4 className="title-create-item">Other Account</h4>
                                            <fieldset>
                                                <h4 className="title-infor-account">Steam</h4>
                                                <input
                                                    type="text"
                                                    placeholder="Steam ID"
                                                    value={profile.link_offer_steam || ''}
                                                    disabled
                                                />
                                                <Link to="#" className="connect">
                                                    <i className="fab fa-steam"></i>Connect to steam
                                                </Link>
                                            </fieldset>*/}
                                        </div>
                                    </div>
                                    <button className="tf-button-submit mg-t-15" type="submit">
                                        Cập nhật hồ sơ
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default EditProfile
